import _ from "lodash";

const trimDetailsMixin = {
    computed: {
        vehicleName() {
            const year = this.trim.year;
            const make = this.trim.make;
            const model = this.trim.model;
            const trim = this.trim.trim;

            let name = `${year} ${make} ${model}`;
            if (trim) {
                name += ` ${trim}`;
            }
            return name;
        },

        bodyStyleOrDefault() {
            if (_.isNil(this.trim.bodyType)) {
                return "sedan";
            }

            return this.trim.bodyType;
        }
    }
};

export default trimDetailsMixin;
